/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBankAccountLookup.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/bank-account-lookup";

export class AutogenModelBankAccountLookup<RowType extends ModelRow> extends Endpoint<RowType, RowBankAccountLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowBankAccountLookup extends ModelRow<RowBankAccountLookupFields> {
	constructor(values?: Partial<RowBankAccountLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowBankAccountLookupFields {
	account_id: string;
	account_number: string;
	address1: string;
	address2: string;
	agent_flag: string;
	ap_flag: string;
	apcod_flag: string;
	balance: number;
	balance_c: string;
	balance_d: Date;
	balance_date: Date;
	balance_gl: string;
	balance_n: number;
	balance_r: number;
	bank_id_no: string;
	bank_name: string;
	bank_user_code: string;
	carrier_flag: string;
	cash_account_glid: string;
	cash_rec_bktrx_id: string;
	city: string;
	company_code: string;
	company_id: string;
	confirmation_code: string;
	contact: string;
	conversion_fee_trx_id: string;
	currency_type: string;
	customer_usage: string;
	descr: string;
	drs_flag: string;
	drscod_flag: string;
	email: string;
	fax: string;
	filename: string;
	id: string;
	is_reconciled: string;
	master_code_id: string;
	next_check_id: string;
	off_flag: string;
	owner_flag: string;
	phone: string;
	positive_pay_enabled: string;
	reconcile_sort: string;
	region_code: string;
	state: string;
	template_num_agent: number;
	template_num_ap: number;
	template_num_apcod: number;
	template_num_dcod: number;
	template_num_drs: number;
	template_num_off: number;
	template_num_owner: number;
	templatenumcarrier: number;
	tmplt_type_carrier: string;
	transfer_bktrx_id: string;
	users_perms_all: string;
	voucher_lines: number;
	website_url: string;
	zip_code: string;
	lm_search: string;
	lm_search_selected: string;
	search: string;
}

